<template>
  <ContentSection  title-tag="div" :title="title" :appearance="appearance">
    <slot />
  </ContentSection>
</template>

<script>
  import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';

  export default {
    name: 'FormSection',
    components: { ContentSection },
    props: {
      title: String,
      appearance: {
        type: String,
        default: 'form-section',
      },
    }
  }
</script>